import React from 'react';
import './Pricing.css';
import useScrollToTop from '../components/useScrollToTop';
import GetQuoteForm from '../components/GetQuoteForm';
import ServiceFeatures from '../components/ServiceFeatures';
import { FaSyncAlt, FaComments, FaCheckCircle } from 'react-icons/fa';
import ReusableLanding from '../components/ReusableLanding';
import image2 from '../img/up_bedromm.webp';
import FAQ from '../components/FAQ';
import pricingFAQData from '../components/pricingFAQData';
import Button from '../components/Button'; // Import the Button component

const Pricing = () => {
  const featuresData = [
    {
      icon: <FaSyncAlt />,
      text: 'Multiple design revisions',
    },
    {
      icon: <FaComments />,
      text: 'Free consultation with experts',
    },
    {
      icon: <FaCheckCircle />,
      text: '100% satisfaction guarantee',
    },
  ];
  useScrollToTop();
  return (
    <>
      <ReusableLanding
        imageUrl={image2}
        title="Our Pricing"
        description="We offer a range of pricing options to suit your needs and budget. Our goal is to provide transparent and competitive pricing for all our services."
      />
      <div className="pricing-page">
       {/* <section className="service-pricing">
          <h2>Architectural Design Services</h2>
          <p>
            Our architectural design services are tailored to your specific
            project requirements. We offer both ready-made and custom design
            packages.
          </p>

          <section className="pricing-section">
            <h2>Our Pricing</h2>
            <div className="pricing-details">
              <div className="pricing-item">
                <h3>
                  Basic <p><strong>Rs. 7,000</strong></p>
                </h3>
                <p>
                  The deliverables includes:
                  <ul>
                    <li>House plan drawings with furniture layout</li>
                    <li>3D exterior elevation designs</li>
                  </ul>
                </p>
                <div className="pricing-bottom">
                <a href="https://wa.me/918828531570" target="_blank" rel="noopener noreferrer">
                  <Button className="button-outlined">ENQUIRE NOW</Button>
                  <a/>
                </div>
              </div>

              <div className="pricing-item">
                <h3>
                  Complete <p><strong>Rs. 14,000</strong></p>
                </h3>
                <p>
                  The deliverables includes:
                  <ul>
                    <li>House plan drawings with furniture layout</li>
                    <li>3D exterior elevation designs</li>
                    <li>Structural drawings</li>
                    <li>Working drawings</li>
                  </ul>
                </p>
                <div className="pricing-bottom">
                  <Button className="button-outlined">ENQUIRE NOW</Button>
                </div>
              </div>

              <div className="pricing-item">
                <h3>
                  Full Set <p><strong>Rs. 21,000</strong></p>
                </h3>
                <p>
                  The deliverables includes:
                  <ul>
                    <li>House plan drawings with furniture layout</li>
                    <li>3D exterior elevation designs</li>
                    <li>Structural drawings</li>
                    <li>Working drawings</li>
                    <li>Drainage drawings</li>
                    <li>Electrical drawings</li>
                    <li>Plumbing drawings</li>
                    <li>A3 size printed plan set</li>
                  </ul>
                </p>
                <div className="pricing-bottom">
                  <Button className="button-outlined">ENQUIRE NOW</Button>
                </div>
              </div>
            </div>
          </section>
        </section>*/}

       {/*<section className="service-pricing">
          <h2>Interior Design Services</h2>
          <p>
            Our interior design services focus on creating beautiful and
            functional spaces that reflect your personal style.
          </p>

          <div className="pricing-details">
            <div className="pricing-item">
              <h3>Home Interior Design</h3>
              <p>Comprehensive interior design for your entire home.</p>
              <p>
                <strong>Starting from:</strong> Rs. 1,500 <small>(per sq ft)</small>
              </p>
              <div className="pricing-bottom">
                  <Button className="button-outlined">ENQUIRE NOW</Button>
                </div>
            </div>

            <div className="pricing-item">
              <h3>Office Interior Design</h3>
              <p>Professional interior design for your office space.</p>
              <p>
                <strong>Starting from:</strong> Rs. 2,500 <small>(per sq ft)</small>
              </p>
              <div className="pricing-bottom">
                  <Button className="button-outlined">ENQUIRE NOW</Button>
                </div>
            </div>

            <div className="pricing-item">
              <h3>Design Consultation</h3>
              <p>Expert advice and design ideas for your project.</p>
              <p>
                <strong>Starting from:</strong> Rs. 100/hour
              </p>
              <div className="pricing-bottom">
                  <Button className="button-outlined">ENQUIRE NOW</Button>
                </div>
            </div>
          </div>
        </section> 

        <section className="pricing-packages">
          <h2>Pricing Packages</h2>
          <p>
            We offer bundled packages for comprehensive design and construction
            projects. These packages provide cost savings and convenience.
          </p>

          <div className="package-details">
            <div className="package-item">
              <h3>Design & Build Package</h3>
              <p>
                Includes architectural design, interior design, and construction
                management.
              </p>
              <p>
                <strong>Starting from:</strong> Rs. 7,000 <small>(per sq ft)</small>
              </p>
              <div className="pricing-bottom">
                  <Button className="button-outlined">ENQUIRE NOW</Button>
                </div>
            </div>

            <div className="package-item">
              <h3>Interior Design & Renovation Package</h3>
              <p>
                Includes interior design and renovation services for a single
                room or entire home.
              </p>
              <p>
                <strong>Starting from:</strong> Rs. 1,800 - Rs. 4,500+ <small>(per sq ft, depending on scope and complexity)</small>
              </p>
              <p className="package-note">
                * Contact us for a detailed quote based on your specific requirements.
              </p>
              <div className="pricing-bottom">
                  <Button className="button-outlined">ENQUIRE NOW</Button>
                </div>
            </div>
          </div>
        </section> */}

        <section className="service-pricing">
          <h2>Construction Services</h2>
          <p>
            We provide full-service construction for residential and commercial
            projects. Our pricing is based on project scope and materials.
          </p>

          <div className="pricing-details">
            <div className="pricing-item">
              <h3>New Home Construction</h3>
              <p>Building your dream home from the ground up.</p>
              <p>
                <strong>Contact us for a quote.</strong>
              </p>
                <a href="https://wa.me/918828531570" target="_blank" rel="noopener noreferrer">
                 <Button className="button-outlined">ENQUIRE NOW</Button>
                </a>
            </div>

            <div className="pricing-item">
              <h3>Renovation and Remodeling</h3>
              <p>Transforming existing spaces to meet your needs.</p>
              <p>
                <strong>Contact us for a quote.</strong>
              </p>
              <a href="https://wa.me/918828531570" target="_blank" rel="noopener noreferrer">
                 <Button className="button-outlined">ENQUIRE NOW</Button>
                </a>
            </div>
            <div className="pricing-item">
  <h3>House Design in Minutes</h3>
  <p>Get your house design quickly and efficiently.</p>
  <p>
    <strong>Contact us for details.</strong>
  </p>
  <a href="https://wa.me/918828531570" target="_blank" rel="noopener noreferrer">
    <Button className="button-outlined">ENQUIRE NOW</Button>
  </a>
</div>

<div className="pricing-item">
  <h3>Floor Plans</h3>
  <p>Detailed and functional floor plan designs.</p>
  <p>
    <strong>Contact us for pricing.</strong>
  </p>
  <a href="https://wa.me/918828531570" target="_blank" rel="noopener noreferrer">
    <Button className="button-outlined">ENQUIRE NOW</Button>
  </a>
</div>

<div className="pricing-item">
  <h3>Customized House Design</h3>
  <p>Tailored house designs to match your unique needs.</p>
  <p>
    <strong>Request a personalized quote.</strong>
  </p>
  <a href="https://wa.me/918828531570" target="_blank" rel="noopener noreferrer">
    <Button className="button-outlined">ENQUIRE NOW</Button>
  </a>
</div>

<div className="pricing-item">
  <h3>House Elevation Design</h3>
  <p>Stunning and practical exterior elevation designs.</p>
  <p>
    <strong>Get elevation design costs.</strong>
  </p>
  <a href="https://wa.me/918828531570" target="_blank" rel="noopener noreferrer">
    <Button className="button-outlined">ENQUIRE NOW</Button>
  </a>
</div>

<div className="pricing-item">
  <h3>Interior Designing</h3>
  <p>Beautiful and functional interior design solutions.</p>
  <p>
    <strong>Discuss your interior needs.</strong>
  </p>
  <a href="https://wa.me/918828531570" target="_blank" rel="noopener noreferrer">
    <Button className="button-outlined">ENQUIRE NOW</Button>
  </a>
</div>

<div className="pricing-item">
  <h3>Vastu Consultancy</h3>
  <p>Expert Vastu advice for harmonious living spaces.</p>
  <p>
    <strong>Enquire about Vastu services.</strong>
  </p>
  <a href="https://wa.me/918828531570" target="_blank" rel="noopener noreferrer">
    <Button className="button-outlined">ENQUIRE NOW</Button>
  </a>
</div>

<div className="pricing-item">
  <h3>2D Floor Plans & Elevations</h3>
  <p>Precise 2D drawings for planning and visualization.</p>
  <p>
    <strong>Get 2D design service details.</strong>
  </p>
  <a href="https://wa.me/918828531570" target="_blank" rel="noopener noreferrer">
    <Button className="button-outlined">ENQUIRE NOW</Button>
  </a>
</div>

<div className="pricing-item">
  <h3>3D Architectural Modeling</h3>
  <p>Detailed 3D models for a realistic view of your project.</p>
  <p>
    <strong>Enquire about 3D modeling.</strong>
  </p>
  <a href="https://wa.me/918828531570" target="_blank" rel="noopener noreferrer">
    <Button className="button-outlined">ENQUIRE NOW</Button>
  </a>
</div>

<div className="pricing-item">
  <h3>3D Rendering & Visualization</h3>
  <p>Photorealistic renderings to bring your designs to life.</p>
  <p>
    <strong>See our rendering portfolio.</strong>
  </p>
  <a href="https://wa.me/918828531570" target="_blank" rel="noopener noreferrer">
    <Button className="button-outlined">ENQUIRE NOW</Button>
  </a>
</div>

<div className="pricing-item">
  <h3>Building Information Modeling (BIM)</h3>
  <p>Comprehensive BIM services for efficient project management.</p>
  <p>
    <strong>Learn about our BIM capabilities.</strong>
  </p>
  <a href="https://wa.me/918828531570" target="_blank" rel="noopener noreferrer">
    <Button className="button-outlined">ENQUIRE NOW</Button>
  </a>
</div>

<div className="pricing-item">
  <h3>Virtual Tours & Walkthroughs</h3>
  <p>Immersive virtual experiences of your future space.</p>
  <p>
    <strong>Request a virtual tour demo.</strong>
  </p>
  <a href="https://wa.me/918828531570" target="_blank" rel="noopener noreferrer">
    <Button className="button-outlined">ENQUIRE NOW</Button>
  </a>
</div>

<div className="pricing-item">
  <h3>3D Interior Design</h3>
  <p>Visualize your interior spaces in stunning 3D.</p>
  <p>
    <strong>Discuss your 3D interior needs.</strong>
  </p>
  <a href="https://wa.me/918828531570" target="_blank" rel="noopener noreferrer">
    <Button className="button-outlined">ENQUIRE NOW</Button>
  </a>
</div>

<div className="pricing-item">
  <h3>Residential Construction</h3>
  <p>Expert construction services for your dream home.</p>
  <p>
    <strong>Get a construction estimate.</strong>
  </p>
  <a href="https://wa.me/918828531570" target="_blank" rel="noopener noreferrer">
    <Button className="button-outlined">ENQUIRE NOW</Button>
  </a>
</div>
          </div>
        </section>

        <section className="get-quote">
          <p>
            For a personalized quote, please contact us with your project
            details. We are happy to provide a free consultation and estimate.
          </p>
          <GetQuoteForm />
        </section>
      </div>
      <ServiceFeatures features={featuresData} />
      <FAQ faqData={pricingFAQData} />
    </>
  );
};

export default Pricing;
